//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
// import 'bootstrap/dist/css/bootstrap.css'
import '~/assets/css/costum-boot-pu.css'
// import { LayoutPlugin, NavbarPlugin,CardPlugin,BAlert,BButton,BreadcrumbPlugin,IconsPlugin, CarouselPlugin  } from 'bootstrap-vue'
import { LayoutPlugin, NavbarPlugin,CardPlugin,BAlert,BButton,BreadcrumbPlugin} from 'bootstrap-vue'
Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(CardPlugin)
Vue.use(BreadcrumbPlugin)
// Vue.use(IconsPlugin)

Vue.component('BAlert', BAlert)
Vue.component('BButton', BButton)
// Vue.use(CarouselPlugin)

export default {
    name: "index",
    head() {
        return {
            htmlAttrs: {
                lang: this.$i18n.locale
            }
        }
    },

//  head() {
//         return this.$nuxtI18nHead({ addSeoAttributes: true })   
//     },
    // BootstrapVue:{
    //   components: ['BAlert','BButton'],
    //     bootstrapVueCSS: false,
    // componentPlugins: [
    //   'LayoutPlugin', 
    //   'BreadcrumbPlugin', 
    //   // 'AlertPlugin',
    //   'CardPlugin',
    //   // 'ButtonPlugin', 
    //   // 'SkeletonPlugin'
    // ],
    // },
    // data(){
    //   // console.log("nev------",process.env.NODE_ENV)
    //   // console.log("lang------",this.$i18n.locale)
    //   return {
    //     lang:this.$i18n.locale
    //   }
    // }
}
